import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutline from "@material-ui/icons/HelpOutline";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
  },
});

const EditRange = () => {
  const classes = useStyles();

  const { rangeId } = useParams();

  const [rangeData, setRangeData] = useState({});
  const [formData, setFormData] = useState({
    range: [],
    carriers: [],
    carrierProtocols: [],
    onboardingStatuses: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      fetchWithToken(`api/Ranges/${rangeId}`),
      fetchWithToken("api/Forms/RangeData"),
    ])
      .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
      .then(([data1, data2]) => {
        setRangeData(data1);
        setFormData({
          carriers: data2.carriers,
          carrierProtocols: data2.carrierProtocols,
          callManagers: data2.callManagers,
          sessionManagers: data2.sessionManagers,
          onboardingStatuses: data2.onboardingStatuses,
          users: data2.gtUsers,
          loading: false,
        });
      });
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm range={rangeData} formData={formData} />
      )}
    </>
  );
};

const EditForm = ({ formData, range }) => {
  const classes = useStyles();
  const history = useNavigate();

  const [rangeData, setRangeData] = useState({ ...range });

  const [submitData, setSubmitData] = useState(rangeData);
  const [editStart, setEditStart] = useState(false);
  const [editEnd, setEditEnd] = useState(false);

  const myChangeHandler = (value, name) => {
    if (value === "") value = null;
    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const [loading, setLoading] = useState(false);

  if (range.onboardDate != null) {
    range.onboardDate = range.onboardDate.split("T")[0];
  }

  if (range.offboardDate != null) {
    range.offboardDate = range.offboardDate.split("T")[0];
  }

  const submitHandler = (e) => {
    e.preventDefault();

    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (submitData.startNumber == null) stringArray.push("Start Number");
    if (submitData.endNumber == null) stringArray.push("End Number");
    if (submitData.carrierId == null) stringArray.push("Carrier");
    if (submitData.smeTcLocation == null) stringArray.push("Session Manager");
    if (submitData.onboardingStatus == null)
      stringArray.push("Onboarding Status");

    if (
      submitData.startNumber == null ||
      submitData.endNumber == null ||
      submitData.carrierId == null ||
      submitData.smeTcLocation == null ||
      submitData.onboardingStatus == null
    ) {
      stringArray.map((error, index) => {
        if (index === stringArray.length - 1)
          errorMesssage += index == 0 ? error : " & " + error;
        else errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    if (
      submitData.startNumber === rangeData.startNumber &&
      submitData.endNumber === rangeData.endNumber &&
      submitData.carrierId === rangeData.carrierId &&
      submitData.carrierCircuitId === rangeData.carrierCircuitId &&
      submitData.carrierProtocol === rangeData.carrierProtocol &&
      submitData.callManagerFqdn === rangeData.callManagerFqdn &&
      submitData.smeTcLocation === rangeData.smeTcLocation &&
      submitData.onboardingEngineer === rangeData.onboardingEngineer &&
      submitData.serviceManager === rangeData.serviceManager &&
      submitData.onboardDate === rangeData.onboardDate &&
      submitData.offboardDate === rangeData.offboardDate &&
      submitData.onboardingStatus === rangeData.onboardingStatus
    ) {
      sendAlert(`No Changes Made`, "warning");
      return;
    }

    setLoading(true);
    var successfulResponse = false;

    fetchWithToken(`api/Ranges/`, "PUT", submitData)
      .then((res) => {
        if (res.ok) successfulResponse = true;
        return res.json();
      })
      .then((data) => {
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
        if (successfulResponse) {
          setRangeData((prev) => ({
            ...prev,
            startNumber: submitData.startNumber,
            endNumber: submitData.endNumber,
            totalCount: submitData.endNumber - submitData.startNumber + 1,
            carrierId: submitData.carrierId,
            carrierCircuitId: submitData.carrierCircuitId,
            carrierProtocol: submitData.carrierProtocol,
            callManagerFqdn: submitData.callManagerFqdn,
            smeTcLocation: submitData.smeTcLocation,
            onboardingEngineer: submitData.onboardingEngineer,
            serviceManager: submitData.serviceManager,
            onboardDate: submitData.onboardDate
              ? submitData.onboardDate.split("T")[0]
              : submitData.onboardDate,
            offboardDate: submitData.offboardDate
              ? submitData.offboardDate.split("T")[0]
              : submitData.offboardDate,
            onboardingStatus: submitData.onboardingStatus,
            carrier: submitData.carrier,
          }));
        }
        console.log("Data Returned: ", data.returnObject);
        setEditStart(false);
        setEditEnd(false);
      });
  };

  const getCarriers = () => {
    return formData.carriers.map((carrier) => {
      return { value: carrier.id, label: carrier.name };
    });
  };

  const getCarrierProtocols = () => {
    return formData.carrierProtocols.map((protocols) => {
      return { value: protocols.value, label: protocols.value };
    });
  };

  const getUsers = () => {
    return formData.users.map((user) => {
      return { value: user.gmid, label: `${user.firstName} ${user.lastName}` };
    });
  };

  const getStatuses = () => {
    return formData.onboardingStatuses.map((status) => {
      return { value: status.value, label: status.description };
    });
  };

  const getStatusName = () => {
    return formData.onboardingStatuses.map((status) => {
      if (status.value == range.onboardingStatus) {
        return status.description;
      }
    });
  };

  const getCallManagers = () => {
    return formData.callManagers.map((callManager) => {
      return { value: callManager.value, label: `${callManager.value}` };
    });
  };

  const getSessionManagers = () => {
    return formData.sessionManagers.map((sessionManager) => {
      return { value: sessionManager.value, label: `${sessionManager.value}` };
    });
  };

  const getUserFromGmid = (gmid) => {
    return formData.users
      .filter((user) => user.gmid == gmid)
      .map((u) => {
        return { value: u.gmid, label: `${u.firstName} ${u.lastName}` };
      });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <form onSubmit={submitHandler}>
                <Typography
                  sx={{ fontSize: 14 }}
                  style={{ margin: "20px", fontSize: "1.5em" }}
                  color="text.secondary"
                  gutterBottom
                  variant="h6"
                  id="tableTitle"
                  component="div"
                >
                  Range ID: {range.id}
                </Typography>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4 col-form-label">
                    <h6>Pool:</h6>
                  </label>
                  <div class="col-sm-8" style={{ paddingTop: "8px" }}>
                    <h6>{range.pool.name}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4 col-form-label">
                    <h6>Start:</h6>
                  </label>
                  <div
                    class="col-sm-8"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {editStart ? (
                      <input
                        type="number"
                        style={{ fontSize: "16px" }}
                        class="form-control"
                        maxLength="25"
                        defaultValue={rangeData.startNumber}
                        onChange={(e) =>
                          myChangeHandler(e.target.value, "startNumber")
                        }
                      />
                    ) : (
                      <h6 style={{ margin: "10px 0 0 13px" }}>
                        {rangeData.startNumber}
                      </h6>
                    )}
                    <Tooltip
                      title={
                        rangeData.totalCount !==
                        rangeData.endNumber - rangeData.startNumber + 1 ? (
                          <>
                            This is a Non-Contiguous Range.
                            <br /> Start & End Numbers Cannot Be Edited.
                          </>
                        ) : (
                          ""
                        )
                      }
                      arrow
                      placement="right"
                    >
                      <span>
                        <Button
                          color="primary"
                          disabled={
                            rangeData.totalCount !==
                            rangeData.endNumber - rangeData.startNumber + 1
                          }
                          onClick={(e) => {
                            clearAlert();
                            setEditStart((prev) => !prev);
                            setSubmitData((prev) => ({
                              ...prev,
                              startNumber: rangeData.startNumber,
                            }));
                          }}
                        >
                          <EditIcon variant="contained" />
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </div>
                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4 col-form-label">
                    <h6>End:</h6>
                  </label>
                  <div
                    class="col-sm-8"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {editEnd ? (
                      <input
                        type="number"
                        style={{ fontSize: "16px" }}
                        class="form-control"
                        maxLength="25"
                        defaultValue={rangeData.endNumber}
                        onChange={(e) =>
                          myChangeHandler(e.target.value, "endNumber")
                        }
                      />
                    ) : (
                      <h6 style={{ margin: "10px 0 0 13px" }}>
                        {rangeData.endNumber}
                      </h6>
                    )}
                    <Tooltip
                      title={
                        rangeData.totalCount !==
                        rangeData.endNumber - rangeData.startNumber + 1 ? (
                          <>
                            This is a Non-Contiguous Range.
                            <br /> Start & End Numbers Cannot Be Edited.
                          </>
                        ) : (
                          ""
                        )
                      }
                      arrow
                      placement="right"
                    >
                      <span>
                        <Button
                          color="primary"
                          disabled={
                            rangeData.totalCount !==
                            rangeData.endNumber - rangeData.startNumber + 1
                          }
                          onClick={(e) => {
                            clearAlert();
                            setEditEnd((prev) => !prev);
                            setSubmitData((prev) => ({
                              ...prev,
                              endNumber: rangeData.endNumber,
                            }));
                          }}
                        >
                          <EditIcon variant="contained" />
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Carrier:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      placeholder={""}
                      defaultValue={
                        rangeData.carrier != null
                          ? {
                              value: rangeData.carrier.id,
                              label: `${rangeData.carrier.name}`,
                            }
                          : ""
                      }
                      options={getCarriers()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "carrierId"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="carrierCircuitId" class="col-sm-4 col-form-label">
                    <h6>Circuit ID:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="carrierCircuitId"
                      maxLength="25"
                      defaultValue={range.carrierCircuitId}
                      onChange={(e) =>
                        myChangeHandler(e.target.value, "carrierCircuitId")
                      }
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Protocols:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      isClearable={true}
                      placeholder={""}
                      defaultValue={
                        rangeData.carrierProtocol != null
                          ? {
                              value: rangeData.carrierProtocol,
                              label: `${rangeData.carrierProtocol}`,
                            }
                          : ""
                      }
                      options={getCarrierProtocols()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "carrierProtocol"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Call Manager Engineer:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      isClearable={true}
                      placeholder={""}
                      defaultValue={
                        rangeData.callManagerFqdn != null
                          ? {
                              value: rangeData.callManagerFqdn,
                              label: `${rangeData.callManagerFqdn}`,
                            }
                          : ""
                      }
                      options={getCallManagers()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "callManagerFqdn"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Session Manager:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      placeholder={""}
                      defaultValue={
                        rangeData.smeTcLocation != null
                          ? {
                              value: rangeData.smeTcLocation,
                              label: `${rangeData.smeTcLocation}`,
                            }
                          : ""
                      }
                      options={getSessionManagers()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "smeTcLocation"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Onboarding Engineer:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      isClearable={true}
                      placeholder={""}
                      defaultValue={
                        rangeData.onboardingEngineer != null
                          ? getUserFromGmid(rangeData.onboardingEngineer)
                          : ""
                      }
                      options={getUsers()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "onboardingEngineer"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Service Manager:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      isClearable={true}
                      placeholder={""}
                      defaultValue={
                        rangeData.serviceManager != null
                          ? getUserFromGmid(rangeData.serviceManager)
                          : null
                      }
                      options={getUsers()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "serviceManager"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="onboardDate" class="col-sm-4 col-form-label">
                    <h6>Onboard Date:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="date"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="onboardDate"
                      defaultValue={range.onboardDate}
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(e.target.value, "onboardDate");
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="offboardDate" class="col-sm-4 col-form-label">
                    <h6>Offboard Date:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="date"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="offboardDate"
                      defaultValue={range.offboardDate}
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(e.target.value, "offboardDate");
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-4 col-form-label">
                    <h6>Onboarding Status:</h6>
                  </label>
                  <div class="col-sm-8">
                    <Select
                      placeholder={""}
                      defaultValue={
                        rangeData.onboardingStatus != null
                          ? {
                              value: rangeData.onboardingStatus,
                              label: getStatusName(),
                            }
                          : ""
                      }
                      options={getStatuses()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "onboardingStatus"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>
                {loading && (
                  <>
                    <div style={{ margin: "25px" }}>
                      <span style={{ display: "table", margin: "0 auto" }}>
                        Please Wait For Update to Finish
                      </span>
                      <LinearProgress />
                    </div>
                  </>
                )}

                <Button
                  type="submit"
                  variant="contained"
                  className={classes.button}
                  color="primary"
                >
                  Update
                </Button>
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={() => history("/range/manage")}
                >
                  Cancel
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditRange;
